<ng-container *ngIf="visible">
  <button mat-button *ngIf="!type || type === 'normal'"
    [color]="color"
    [disabled]="disabled"
    [id]="id"
    (click)="buttonClick.emit()">
    {{ name | uppercase}}
    <mat-icon *ngIf="icon" attr.aria-label="{{name}}" class="button-icon">{{icon}}</mat-icon>
  </button>
  <button mat-flat-button *ngIf="type === 'flat'"
    [color]="color"
    [disabled]="disabled"
    [id]="id"
    (click)="buttonClick.emit()">
    {{ name | uppercase }}
    <mat-icon *ngIf="icon" attr.aria-label="{{name}}" class="button-icon">{{icon}}</mat-icon>
  </button>
  <button mat-raised-button *ngIf="type === 'raised'"
    [color]="color"
    [disabled]="disabled"
    [id]="id"
    (click)="buttonClick.emit()">
    {{ name | uppercase}}
    <mat-icon *ngIf="icon" attr.aria-label="{{name}}" class="button-icon">{{icon}}</mat-icon>
  </button>
</ng-container>
